import {FACTIONS} from "../../../constants/factions";

export const TECHNODWARVES_QUOTES = [{
  quote: 'Таран ломает ворота. Требюшет — стены. А наш новый чертёж — саму идею, что их можно защитить',
  author: 'Гунд Меткий, старшина самого результативного расчета технодворфов Дразмагана',
  factionId: FACTIONS.TECHNODWARVES
}, {
  quote: 'Рыцарь тренируется двадцать лет. Наши наводчики — две недели. И они точнее',
  author: 'Рейнхард Затвор, командир артиллерийского легиона технодворфов Дразмагана',
  factionId: FACTIONS.TECHNODWARVES
}, {
  quote: 'Мы не изобретаем оружие. Мы изобретаем способы сделать оружие врага бесполезным',
  author: 'Мехтильд Медь, технодворф-цензор технической документации Дразмагана',
  factionId: FACTIONS.TECHNODWARVES
}, {
  quote: 'Война не меняется. Меняются только инструменты войны',
  author: 'Торбьёрн Старейший, технодворф-хранитель Кузни Хадмазата',
  factionId: FACTIONS.TECHNODWARVES
}, {
  quote: 'Осадное орудие — самая убедительная дипломатия',
  author: 'Отто Ковочный, технодворф-надзиратель пороховых складов Хадмазата',
  factionId: FACTIONS.TECHNODWARVES
}]